"use client";

import {
  QueryClientProvider,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import getQueryClient from "~/lib/getQueryClient";
import { FetchLoading } from "~/components/ui/FetchLoading";
import React from "react";
import { getOpeningHour } from "~/app/api/_backend/branch";
import OpeningHourCard, { getTitle } from "~/components/ui/OpeningHourCard";

export default function OpeningHourSection() {
  const queryClient = getQueryClient();

  return (
    <>
      <section>
        <QueryClientProvider client={queryClient}>
          <Content />
        </QueryClientProvider>
      </section>
    </>
  );
}

function Content() {
  const queryClient = useQueryClient();

  const { isPending, isError, data } = useQuery({
    queryKey: ["opening_hours"],
    queryFn: async () => await getOpeningHour({}),
  });

  if (isPending) {
    return (
      <div className="flex justify-center">
        <FetchLoading />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="mt-5 flex w-full items-center justify-center text-primary">
        <div>
          Nepodařilo se načíst otevírací dobu.{" "}
          <span
            onClick={() =>
              queryClient.invalidateQueries({ queryKey: ["opening_hours"] })
            }
            className="underline transition-all hover:cursor-pointer hover:no-underline hover:brightness-75"
          >
            Načíst znova
          </span>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="grid gap-10 xl:grid-cols-2">
        {data?.map((hours, idx) => {
          return (
            <OpeningHourCard
              key={idx}
              active={hours.active}
              title={getTitle(hours.season)}
              dates={hours.openingHours}
            />
          );
        })}
      </div>
    </>
  );
}
